import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppHeader } from "@/components/AppHeader";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Languages from "@/pages/Languages";
import Placement from "@/pages/Placement";
import LevelMap from "@/pages/LevelMap";
import Lesson from "@/pages/Lesson";
import Assessment from "@/pages/Assessment";
import Tutor from "@/pages/Tutor";
import Dashboard from "@/pages/Dashboard";
import Review from "@/pages/Review";

const Protected = () => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center"><div className="h-10 w-10 rounded-full border-4 border-emerald-200 border-t-emerald-600 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-[hsl(var(--bg))]">
      <AppHeader />
      <main><Outlet /></main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route element={<Protected />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/languages" element={<Languages />} />
            <Route path="/placement/:lang" element={<Placement />} />
            <Route path="/learn/:lang" element={<LevelMap />} />
            <Route path="/lesson/:lang/:level/:topic" element={<Lesson />} />
            <Route path="/assessment/:lang/:level/:topic" element={<Assessment />} />
            <Route path="/tutor/:lang" element={<Tutor />} />
            <Route path="/review/:lang" element={<Review />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
